<template lang="pug">
  main
    NavBarRequisiciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Requisición Nueva &nbsp
              a.button.is-dark.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Seleccionar Bienes o Servicios para compra&nbsp
                  span.tag.is-success(v-if="itemsSeleccionados.length > 0")
                    | {{ itemsSeleccionados.length }} Seleccionado(s)
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  ListItems(:tickets_solicitudes='tickets_solicitudes' :tickets_solicitudesSel='tickets_solicitudesSel' @countItems="checkItemsSel")
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Formulario Requisiciones&nbsp
                  span.tag.is-success(v-if="Object.keys(this.formularioReq).length > 0")
                    | Completo
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormRequisicion(:getDataForm="isGetDataForm" :usuarios="usuarios" @send-FormReq="checkForm")
        .columns
          .column.is-12.has-text-centered
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Desglose de Bienes o Servicios&nbsp
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  ListItemsDesglose(:items="itemsSeleccionados" :itemsRequisicion="itemsRequisicion" :baseArticulos="baseArticulos" @itemsChanged='checkItemsSaved')
        .columns
          .column.is-12
            a.button.is-black.is-rounded(@click="guardarRequisicion" :disabled="isDisabled")
              | Guardar Requisición
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisiciones from './layout/NavBarRequisicion.vue'
  import FormRequisicion from '../requisiciones_Componentes/FormRequisicion.vue'
  import FormAgregarCotizacion from '../requisiciones_Componentes/FormAgregarCotizacion.vue'
  import NotificacionData from './NotificacionData'
  import ListItems from './ListItems.vue'
  import ListItemsDesglose from './ListItemsDesglose.vue'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import autotanqueServices from '../../services/autotanque'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '../../services/usuarios/usuarios'
  var convertir = require('numero-a-letras')

  export default {
    name: 'RequisicionEditar',
    components: { Loader, NavBarRequisiciones, NotificacionData, FormRequisicion, ListItems, BulmaAccordion, BulmaAccordionItem, FormAgregarCotizacion, ListItemsDesglose },
    data() {
      return {
        isLoading: true,
        isDisabled: true,
        isGetDataForm: true,
        itemsSeleccionados: [],
        itemsSaved: [],
        usuarios: [],
        formularioReq: {},
        isSaveRequisicion: false,
        itemsExcel_G: 0,
        itemsReq_G: 0,
        itemsCot_G: 0,
        baseArticulos: [],
        tickets: [],
        solicitudes: [],
        tickets_solicitudes: [],
        tickets_solicitudesSel: [],
        itemsRequisicion: [],
        dataRequisicion: {}
      }
    },
    watch: {
      itemsSeleccionados () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioReq).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveRequisicion = true
        } else {
          this.isSaveRequisicion = false
        }
      },
      formularioReq () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioReq).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveRequisicion = true
        } else {
          this.isSaveRequisicion = false
        }
      },
      itemsSaved () {
        if (this.itemsSeleccionados.length > 0 && Object.keys(this.formularioReq).length > 0 && this.itemsSaved.length > 0) {
          this.isSaveRequisicion = true
        } else {
          this.isSaveRequisicion = false
        }
      },
      isSaveRequisicion () {
        if (this.isSaveRequisicion) {
          this.isDisabled = false
        } else {
          this.isDisabled = true
          console.log('Algun formulario tiene algo faltante')
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },
      obtenerUsuarios () {
        usuariosServices.getUsuarios()
          .then(res => {
            if (res.length > 0) {
              this.usuarios = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
              this.getBaseArticulos()
            }
          })
          .catch(error=> {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },
      getBaseArticulos() {
        InventarioServices.getBaseArticulos()
          .then((data) => {
            this.baseArticulos = data.map(this.convertArticulo)
            this.getTickets()
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },
      getTickets () {
        InventarioServices.getItemsPresupuesto('ALL')
          .then( data => {
            this.tickets = data.map(this.convertirItems)
            this.getSolicitudes()
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },
      getSolicitudes() {
        InventarioServices.getSolicitudes_All()
          .then(data => {
            this.solicitudes = data.map(this.convertirSolicitud)
            this.getTickets_Solicitudes()
          })
          .catch(error => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`)
          })
      },
      convertArticulo (art) {
        return {
          ...art,
          text: `${art.marca} - ${art.modelo} ~ ${art.categoria} ${art.subcategoria}`
        }
      },
      convertirSolicitud (sol) {
        let priorConv = 0
        switch (parseInt(sol.prioridad)) {
          case 0:
            priorConv = 8
            break
          case 1:
            priorConv = 7
            break
          case 2:
            priorConv = 0
            break
        }
        return {
          ...sol,
          id: `s-${sol.id}`,
          area: parseInt(sol.area),
          cantidad: parseInt(sol.cantidad),
          departamento: parseInt(sol.departamento),
          estado: parseInt(sol.estado),
          restante: priorConv,
          tipo: 's',
          problema: sol.razon, 
          solicita: sol.oficina,
          resuelve: sol.solicita
        }

      },
      getTickets_Solicitudes () {
        this.tickets.map( ticket => this.tickets_solicitudes.push(ticket))
        this.solicitudes.map( sol => this.tickets_solicitudes.push(sol))
        this.getListItems()  
      },
      checkForm (dataReq) {
        if (dataReq === 'editar') {
          this.isGetDataForm = true
        } else {
          this.formularioReq = Object.assign({}, this.formularioReq, dataReq)
          this.isGetDataForm = false
        }
      },
      checkItemsSel (items) {
        this.itemsSeleccionados = items
      },
      checkItemsSaved(items) {
        this.itemsSaved = []
        this.itemsSaved = items
      },
      guardarRequisicion () {
        if (this.isSaveRequisicion) {
          this.isLoading = true
          
          let cantidadNp = 0

          if (this.formularioReq.presupuestada == 1) {
            cantidadNp = 0
          } else {
            cantidadNp = this.formularioReq.totalSel
          }

          let totalStr = convertir.NumerosALetras(this.formularioReq.totalSel)
              
          InventarioServices.updateRequisicion(this.requisicionEdit.id, this.requisicionEdit.id_requisicion, this.formularioReq.fecha, this.formularioReq.area, this.formularioReq.tipo, this.formularioReq.ubicacion, this.formularioReq.presupuestada, cantidadNp, this.formularioReq.partida, this.formularioReq.justificacion, this.formularioReq.cotizacion, this.formularioReq.monedaSel, this.formularioReq.subtotalSel, this.formularioReq.ivaSel, this.formularioReq.totalSel, totalStr, this.formularioReq.entregaI, this.formularioReq.nombreBienServicio, this.formularioReq.especificaciones, this.formularioReq.comentarios, this.formularioReq.incluye, this.formularioReq.condiciones, this.formularioReq.proveedor1.id, this.formularioReq.monedaP1, this.formularioReq.totalP1, this.formularioReq.proveedor2.id, this.formularioReq.monedaP2, this.formularioReq.totalP2, this.formularioReq.proveedor3.id, this.formularioReq.monedaP3, this.formularioReq.totalP3, this.formularioReq.proveedorAsignado, this.formularioReq.userSolicita.id, this.formularioReq.userSolicita.nombre, this.formularioReq.userPlantel.id, this.formularioReq.userPlantel.nombre, this.formularioReq.userJefeArea.id, this.formularioReq.userJefeArea.nombre,  this.formularioReq.userRevisa.id, this.formularioReq.userRevisa.nombre, this.formularioReq.userAutoriza.id, this.formularioReq.userAutoriza.nombre)
            .then( rAdd => {
              if (rAdd.success) {

                this.itemsSaved.forEach(item => {
                  InventarioServices.addRequisicion_Item(this.requisicionEdit.id, item.id_equipo, item.id, item.cantidad, item.unidadM, item.precioUnit, item.importe, item.tipo)
                    .then( rItem_Req => {
                      if (rItem_Req.success) {
                        this.itemsReq_G++

                          if (this.itemsReq_G === this.itemsSaved.length) {
                            let i = 0
                            this.formularioReq.cotizaciones.forEach(cot => {

                              if (cot.status) {
                                InventarioServices.updateCotizacion(this.requisicionEdit.id, cot.idUsuario, cot.usuario, cot.fileName, this.requisicionEdit.cotizaciones[i].idCotizacion, this.requisicionEdit.cotizaciones[i].rutaFileCot, cot.file)
                                  .then( rAddCot => {
                                    if (rAddCot.success){   
                                      this.itemsCot_G++
                                    } else {
                                      this.itemsCot_G++
                                      this.displayToast(rAddCot.respuesta, 'ban', 'OK')
                                    }
                                    if (this.itemsCot_G === this.formularioReq.cotizaciones.length) {
                                      this.isLoading = false
                                      this.$router.push('/Requisiciones')
                                    } else {
                                      this.isLoading = false
                                      console.log(`Van ${this.itemsCot_G} de ${this.formularioReq.cotizaciones.length} cotizaciones.`)
                                    }
                                  })
                                  .catch( e4 => {
                                    this.isLoading = false
                                    this.displayToast(`(4) Error: ${e4.message}`)
                                  })

                              } else {
                                this.itemsCot_G++
                                if (this.itemsCot_G === this.formularioReq.cotizaciones.length) {
                                  this.isLoading = false
                                  this.$router.push('/Requisiciones')
                                }
                              }
                              i++
                                
                            })
                          } else {
                            console.log(`Van ${this.itemsReq_G} guardados`)
                          }
                      } else {
                        this.isLoading = false
                        this.displayToast(rItem_Req.respuesta, 'ban', 'OK')
                      }
                    })
                    .catch( e3 => {
                      this.isLoading = false
                      this.displayToast(`(3) Error: ${e3.message}`, 'ban', 'OK')
                    })
                })
              } else {
                this.isLoading = false
                this.displayToast(`Error: ${rAdd.respuesta}`, 'ban', 'OK')
              }
            })
            .catch( e2 => {
              this.isLoading = false
              this.displayToast(`(2) Error: ${e2.message}`, 'ban', 'OK')
              })
        }
      },
      backPage () {
        this.$router.back()
      },
      getListItems() {
        InventarioServices.getItems_Requisiciones(this.requisicionEdit.id)
          .then(data => {
            this.itemsRequisicion = data.map(this.convetirItems_Req)

            const _tickets = this.tickets_solicitudes.filter( item => item.tipo === 't')
            const _solicitudes = this.tickets_solicitudes.filter( item => item.tipo === 's')

            _tickets.map( tick => {
              this.itemsRequisicion.map( itemReq => {
                if (tick.id === itemReq.id_ticket) {
                  this.tickets_solicitudesSel.push(tick)
                }
              })
            })

            _solicitudes.map( solic => {
              this.itemsRequisicion.map( itemReq => {
                if (solic.id === `s-${itemReq.id_solicitud}`) {
                  this.tickets_solicitudesSel.push(solic)
                }
              })
            })
            this.dataRequisicion = this.requisicionEdit
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },
      convetirItems_Req (item) {
        return {
          ...item,
          cantidad: parseInt(item.cantidad),
          unidadMedida: parseInt(item.unidadMedida)
        }
      },
      convertirItems(items) {
        return {
          ...items,
          id: items.id,
          departamento: parseInt(items.departamento),
          estado: parseInt(items.estado),
          compra: parseInt(items.compra),
          idResolucion: parseInt(items.idResolucion),
          diagnostico: parseInt(items.diagnostico),
          restante: parseInt(items.restante),
          area: parseInt(items.area),
          tipo: 't'
        }
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'requisicionEdit'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/RequisicionEditar.vue